import { axiosInstance } from "../config/axios";

export interface Bill {
  _id: string;
  entityId: number;
  month: number;
  year: number;
  totalSales: number;
  billingPeriod: string;
  billAmount: number;
  generatedDate: Date;
  dueDate: Date;
  paidOn?: Date;
  status: "PENDING" | "PAID" | "OVERDUE";
  createdAt: Date;
  updatedAt: Date;
}

export interface PayBillResponse {
  redirectUrl: string;
}

export interface ConfirmPaymentResponse {
  status: "PENDING" | "PAID" | "FAILED";
  billId: string;
  amount: number;
  message: string;
}

export interface BillSummary {
  totalAmount: number;
  isOverdue: boolean;
  nearestDueDate: Date;
  unpaidBillsCount: number;
}

class BillingService {
  static async fetchBills(): Promise<Bill[]> {
    const response = await axiosInstance.get<Bill[]>("/bills");
    return response.data;
  }

  static async payBill(id: string): Promise<PayBillResponse> {
    const response = await axiosInstance.get<PayBillResponse>(`/bills/${id}/pay`);
    return response.data;
  }

  static async confirmPayment(id: string): Promise<ConfirmPaymentResponse> {
    const response = await axiosInstance.get<ConfirmPaymentResponse>(`/bills/${id}/confirm`);
    return response.data;
  }

  static async getBillSummary(): Promise<BillSummary> {
    const response = await axiosInstance.get<BillSummary>("/bills/summary");
    return response.data;
  }
}

export { BillingService };
export const billingService = new BillingService();
